export default "__VITE_ASSET__FwBl$MI1__"